"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
var material_1 = require("@angular/material");
var report_export_dialog_1 = require("./report-export-dialog/report-export.dialog");
var report_publish_dialog_component_1 = require("./report-publish-dialog/report-publish-dialog.component");
var report_export_delimiter_dialog_1 = require("./report-export-delimiter-dialog/report-export-delimiter.dialog");
var ReportExportMenuComponent = /** @class */ (function () {
    function ReportExportMenuComponent(dialog) {
        this.dialog = dialog;
        // Enum which specified export types in report.
        this.ExportType = idm_report_export_service_client_js_1.ExportType;
        this.showOnlyCsv = false;
        // In case message with appropriate key exists, export 3dot button will be replaced with mentioned message button
        this.exportButtonLabel = 'reporting.controls.control-export.button.label';
        this.export = new core_1.EventEmitter();
        this.pageOrientation = new core_1.EventEmitter();
        this.csvDelimiter = new core_1.EventEmitter();
    }
    /**
     * These method calls every time when some export type was selected, and it emit selected export time out.
     * @param exportType
     */
    ReportExportMenuComponent.prototype.exportReport = function (exportType) {
        this.export.emit(exportType);
    };
    ReportExportMenuComponent.prototype.openReportExportDialog = function (exportType) {
        var _this = this;
        this.dialog.open(report_export_dialog_1.ReportExportDialogComponent, {
            width: '500px',
            data: {
                selectedExportType: exportType,
                addPageOrientation: function (orientation) { return _this.addPageOrientation(orientation); },
                exportReport: function () { return _this.exportReport(exportType); }
            }
        });
    };
    ReportExportMenuComponent.prototype.openReportExportDelimiterDialog = function (exportType) {
        var _this = this;
        this.dialog.open(report_export_delimiter_dialog_1.ReportExportDelimiterDialogComponent, {
            width: '480px',
            data: {
                selectedExportType: exportType,
                addCsvDelimiter: function (csvDelimiter) { return _this.addCsvDelimiter(csvDelimiter); },
                exportReport: function () { return _this.exportReport(exportType); }
            }
        });
    };
    ReportExportMenuComponent.prototype.openReportPublishDialog = function () {
        this.dialog.open(report_publish_dialog_component_1.ReportPublishDialogComponent, {
            width: '500px',
            data: {
                widgetId: this.widgetId,
                getExportDto: this.getExportDto,
                pageId: this.pageId
            }
        });
    };
    ReportExportMenuComponent.prototype.addPageOrientation = function (orientation) {
        this.pageOrientation.emit(orientation);
    };
    ReportExportMenuComponent.prototype.addCsvDelimiter = function (csvDelimiter) {
        this.csvDelimiter.emit(csvDelimiter);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], ReportExportMenuComponent.prototype, "widgetId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Function)
    ], ReportExportMenuComponent.prototype, "getExportDto", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], ReportExportMenuComponent.prototype, "pageId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], ReportExportMenuComponent.prototype, "hasPublishingAccess", void 0);
    __decorate([
        core_1.Input('show-only-csv'),
        __metadata("design:type", Boolean)
    ], ReportExportMenuComponent.prototype, "showOnlyCsv", void 0);
    __decorate([
        core_1.Output('exportEmitter'),
        __metadata("design:type", core_1.EventEmitter)
    ], ReportExportMenuComponent.prototype, "export", void 0);
    __decorate([
        core_1.Output('pageOrientationEmitter'),
        __metadata("design:type", core_1.EventEmitter)
    ], ReportExportMenuComponent.prototype, "pageOrientation", void 0);
    __decorate([
        core_1.Output('csvDelimiterEmitter'),
        __metadata("design:type", core_1.EventEmitter)
    ], ReportExportMenuComponent.prototype, "csvDelimiter", void 0);
    ReportExportMenuComponent = __decorate([
        core_1.Component({
            
            selector: 'sis-report-export-menu',
            styles: [require('./report-export-menu.component.css')],
            template: require('./report-export-menu.component.html')
        }),
        __metadata("design:paramtypes", [material_1.MatDialog])
    ], ReportExportMenuComponent);
    return ReportExportMenuComponent;
}());
exports.ReportExportMenuComponent = ReportExportMenuComponent;
//# sourceMappingURL=report-export-menu.component.js.map